export default {
	module: {
		namespaced: true,
		
		state: {
			currentPath: '/',
			currentRoute: null
		},
		getters: {
			persist(state) {
				return {
					currentPath: state.currentPath
				};
			}
		},
		mutations: {
			setRoute(state, route) {
				const routeData = Object.assign({}, route);
				delete routeData.matched;

				state.currentPath = routeData.path;
				state.currentRoute = routeData;
			}
		}
	}
}